// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-common-Section-module__root--2v4bk"};